import React from "react";
import {valueWithCommas} from "../../../../../../utils/constants"


const LineBarChart = (props) => {

  const { getChartData, onGetTotalSpending, money } = props || {}

  return(
      <div className="graph-left">
          <div className="line-bar-chart">
              <div className="chart-inner-text d-flex mb-3">
                  <div className="pr-15" style={{width: ""}}>
                      <div>
                          <h3 className="ci-title">${valueWithCommas(onGetTotalSpending() || 0)}</h3>
                      </div>
                      <div>
                          <span className="ci-value">Total Spending</span>
                      </div>
                  </div>
                  <div className="reward-txs pl-15" style={{width: ""}}>
                      <div>
                          <h3 className="ci-title reward-color">${valueWithCommas(money || 0)}</h3>
                      </div>
                      <div>
                          <span className="ci-value reward-color">Reward Value</span>
                      </div>
                  </div>
              </div>
              <div className="line-chart-area">
                  {
                      (getChartData() || []).map((x, index) => (
                          <div key={index.toString()} className="chart-line" style={{width: x.percentage, background: x.color}}/>
                      ))
                  }
              </div>
          </div>
      </div>
  )
}

export default LineBarChart
